var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 1.33398C4.31778 1.33398 1.33301 4.31875 1.33301 8.00065C1.33301 11.6825 4.31778 14.6673 7.99967 14.6673C11.6816 14.6673 14.6663 11.6825 14.6663 8.00065C14.6663 4.31875 11.6816 1.33398 7.99967 1.33398ZM2.30862 8.00065C2.30862 4.85757 4.85659 2.30959 7.99967 2.30959C11.1428 2.30959 13.6907 4.85757 13.6907 8.00065C13.6907 11.1437 11.1428 13.6917 7.99967 13.6917C4.85659 13.6917 2.30862 11.1437 2.30862 8.00065ZM7.49967 11.334V7.00065C7.49967 6.72451 7.72353 6.50065 7.99967 6.50065C8.27582 6.50065 8.49967 6.72451 8.49967 7.00065V11.334C8.49967 11.6101 8.27582 11.834 7.99967 11.834C7.72353 11.834 7.49967 11.6101 7.49967 11.334ZM8.49967 4.66732C8.49967 4.39118 8.27582 4.16732 7.99967 4.16732C7.72353 4.16732 7.49967 4.39118 7.49967 4.66732V5.00065C7.49967 5.27679 7.72353 5.50065 7.99967 5.50065C8.27582 5.50065 8.49967 5.27679 8.49967 5.00065V4.66732Z",
    fill: "#151F57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.f1dd7dd840601f64b889d796e464f54b.svg";
export { ForwardRef as ReactComponent };